<template lang="html">
  <div class="">
    <div id="sidebar-wrapper">
            <ul class="sidebar-nav" style="margin-top: 45px">
                <li class="sidebar-brand">
                    <a href="#">
                        Save/Load Goes Here
                    </a>
                </li>
                <!-- <li>
                    <a href="#">Dashboard</a>
                </li>
                <li>
                    <a href="#">Shortcuts</a>
                </li>
                <li>
                    <a href="#">Overview</a>
                </li>
                <li>
                    <a href="#">Events</a>
                </li>
                <li>
                    <a href="#">About</a>
                </li>
                <li>
                    <a href="#">Services</a>
                </li>
                <li>
                    <a href="#">Contact</a>
                </li> -->
            </ul>
        </div>
        <!-- /#sidebar-wrapper -->
  </div>

</template>

<script>
export default {
}
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// Sidebar.vue?364490fb